<template>
  <!-- <div Main Page Wrapper"> -->
  <div :class="['wrapper', classes]">
    <!-- Horizontal bar at top. Contains messages, notifications, tasks and user menu -->
    <maincontent-header></maincontent-header>

    <!-- Left side column. contains the logo and sidebar -->
    <sidebar />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <ul class="flex-container" style="background-color='gray'">
        <!-- <ul class="d-flex flex-row list-unstyled breadcrumb justify-content-between"> -->
          <div>
            <li>Route : {{$route.name.toUpperCase() }}<small><i>{{ $route.meta.description }}</i></small></li>
          </div>
          <!-- <div class="d-flex flex-row list-unstyled">🌏 -->
          <div class="flex-container nav">
            <!-- <li><a href="/"><i class="fas fa-home"></i>Home</a> | </li> -->
            <!-- <li><router-link to="/about"><i class="fas fa-home"></i> About</router-link> | </li> -->
            <li><router-link to="/about"><span class="icon">📝</span> About</router-link> | </li>
            <!-- <li><router-link to="/world"><i class="fa fa-globe-asia"></i> World</router-link> | </li>
            <li><router-link to="/india"><i class="indicon"></i> India</router-link></li> -->
            <li><router-link to="/world"><span class="icon">🌏</span> World</router-link> | </li>
            <li><router-link to="/india"><i class="indicon"></i> India</router-link></li>
          </div>
          <div>
            <li><small>{{new Date()}}</small></li>
          </div>
        </ul>
      </section>

      <router-view />
    </div>
    <!-- Horizontal bar at bottom. Contains copy right -->
    <maincontent-footer></maincontent-footer>
  </div>
</template>

<script>

import MaincontentHeader from "./layout/MaincontentHeader.vue";
import MaincontentFooter from "./layout/MaincontentFooter.vue";
import Sidebar from "./layout/Sidebar.vue";

export default {
  name: "Maincontent",

  components: {
    MaincontentHeader,
    MaincontentFooter,
    Sidebar
  },
  data() {
    return {
      classes: {
        fixed_layout: "config.fixedLayout",
        hide_logo: "config.hideLogoOnMobile"
      },
    };
  },
};
</script>

<style scoped lang="scss">
  @import "../scss/maincontent";
</style>
